@if (gameInfo$ | async; as adventureGame) {
  <ion-content>
    <img
      src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2Fleft-arrow_800x800.png?alt=media"
      alt=""
      (click)="back()"
      class="back-btn"
      />
      <swiper class="thumbnails" [config]="slidesOpts">
        <ng-template swiperSlide class="tap-img">
          <img src="{{ adventureGame?.adventure_page_banner_url }}" alt="" class="header-img" />
        </ng-template>
        @for (subGameGif of adventureGame?.sub_game_gif; track subGameGif; let i = $index) {
          <ng-template swiperSlide class="tap-img">
            <img src="{{ adventureGame?.sub_game_gif[index] }}" alt="" class="header-img" />
          </ng-template>
        }
      </swiper>
      <div class="four-section">
        <ion-row>
          <p class="tapAndHold">
            {{
            ("game_details_page.tap_and_hold" | translate)
            ? ("game_details_page.tap_and_hold" | translate)
            : "Tap and hold to preview game"
            }}
          </p>
        </ion-row>
        <ion-row class="four-img">
          @for (subGame of adventureGame?.sub_game; track subGame; let i = $index) {
            <ion-col size="3" @gamethumbBounceIn>
              <div class="four-img-item" [ngClass]="{ active: defaultSlider === i }">
                <img
                  src="{{ subGame }}"
                  alt=""
                  class=""
                  (touchstart)="touchStart($event, 1, i)"
                  (touchend)="touchEnd()"
                  (mousedown)="touchStart($event, 1, i)"
                  (mouseup)="touchEnd()"
                  />
                </div>
              </ion-col>
            }
          </ion-row>
        </div>
        <div class="blue-bg">
          <div class="points-desc">
            <h6 class="points">
              {{ adventureGame?.adventure_price }}
              {{
              ("game_details_page.points_per_play" | translate)
              ? ("game_details_page.points_per_play" | translate)
              : "points per play"
              }}
            </h6>
            <h5 class="total-prize">{{('game_details_page.total_prizes' | translate) ? ('game_details_page.total_prizes' | translate) : 'Total prizes'}}: {{ gameTotalPrize }}</h5>
            <p class="start-journey">{{ adventureShortTitle }}</p>
            <p class="learn-more-details">{{ learnMoreDetails }}</p>
            <p class="learn-more-rules">{{ learnMoreRules }}</p>
          </div>
          <div class="main-con custom-rating-grid">
            <section class="progress-section">
              <h2 class="title">
                {{
                ("game_details_page.your_progress" | translate)
                ? ("game_details_page.your_progress" | translate)
                : "Your progress"
                }}
              </h2>
              <p class="title">
                20
                {{
                ("game_details_page.levels_in_total" | translate)
                ? ("game_details_page.levels_in_total" | translate)
                : "levels in total"
                }}
              </p>
              <swiper #progressSlides [config]="slidesOptions">
                @for (slides of adventureGame?.goal_content; track slides; let i = $index) {
                  <ng-template swiperSlide>
                    <ion-row>
                      @for (goal of slides; track goal; let ind = $index) {
                        <ion-col
                          size="3"
                          [ngClass]="ind == 8 ? 'lastrow' : ind == 9 ? 'frow' : ''"
                          >
                          <div class="progress-box">
                            @if (goal?.goal_status != 'Locked') {
                              <div
                                class="inner-box"
                    [ngClass]="{
                      'orange-bg': goal?.goal_status == 'Next',
                      'unlocked-color': goal?.star_collected > 0
                    }"
                                >
                                {{ goal?.goal_number }}
                              </div>
                            }
                            @if (goal?.goal_status == 'Locked') {
                              <div class="inner-box">
                                <img src="assets/images/lock.svg" alt="Lock" />
                              </div>
                            }
                            @if (goal?.star_collected > 0) {
                              <div class="stars-con">
                                <ul>
                                  <li>
                                    <img
                                      class="two-stars"
                          [src]="
                            goal?.star_collected > 0 ? 'assets/images/small-star.svg' : 'assets/images/star-inactive.svg'
                          "
                                      alt="Lock"
                                      />
                                    </li>
                                    <li class="more-space">
                                      <img
                                        class="center-star"
                          [src]="
                            goal?.star_collected > 1 ? 'assets/images/small-star.svg' : 'assets/images/star-inactive.svg'
                          "
                                        alt="Lock"
                                        />
                                      </li>
                                      <li>
                                        <img
                                          class="two-stars"
                          [src]="
                            goal?.star_collected > 2 ? 'assets/images/small-star.svg' : 'assets/images/star-inactive.svg'
                          "
                                          alt="Lock"
                                          />
                                        </li>
                                      </ul>
                                    </div>
                                  }
                                </div>
                              </ion-col>
                            }
                          </ion-row>
                        </ng-template>
                      }
                    </swiper>
                  </section>
                </div>
                <div class="arrows">
                  <ion-icon name="chevron-back-outline" (click)="slidePrev()" class="back"></ion-icon>
                  <ion-icon name="chevron-forward-outline" (click)="slideNext()" class="forward"></ion-icon>
                </div>
              </div>
              <h5 class="archived-stars">
                {{
                ("game_details_page.stars_achieved" | translate)
                ? ("game_details_page.stars_achieved" | translate)
                : "Stars achieved"
                }}
                <span class="star-score">{{ adventureGame?.star_collected }}</span>
                <span class="score-star"><img src="../../../../assets/images/small-star.svg" alt="" /></span>
              </h5>
              @for (item of adventureGame?.prize_content; track item; let i = $index) {
                @if (!item?.is_achieved) {
                  <ion-row class="shild-row">
                    <ion-col size="4" class="shild">
                      <img src="{{ item.prize_deactive_image }}" alt="" />
                    </ion-col>
                    <ion-col size="6">
                      <h4 class="shild-amount">{{ item?.prize }}</h4>
                      <p class="prize-win">
                        {{
                        ("game_details_page.prize_to_win" | translate)
                        ? ("game_details_page.prize_to_win" | translate)
                        : "Prize to win"
                        }}
                      </p>
                      <ion-progress-bar value="{{ item.progress / 100 }}" class="progress-bar"></ion-progress-bar>
                      <button
                        class="stars-btn"
                        [ngStyle]="{ 'background-color': item.prize_light_color, color: item.prize_dark_color }"
                        >
                        {{ item.star_required }}
                        {{ ("game_details_page.stars" | translate) ? ("game_details_page.stars" | translate) : "Stars" }}
                      </button>
                    </ion-col>
                    <hr class="hr" />
                  </ion-row>
                }
              }
              @if (isAchievedAvailable) {
                <h5 class="archived-stars">
                  {{
                  ("game_details_page.prizes_achieved" | translate)
                  ? ("game_details_page.prizes_achieved" | translate)
                  : "Prizes achieved"
                  }}
                  <span class="score-star"><img src="../../../../assets/images/small-star.svg" alt="" /></span>
                </h5>
                @for (item of adventureGame?.prize_content; track item; let i = $index) {
                  @if (item?.is_achieved) {
                    <ion-row class="shild-row">
                      <ion-col size="4" class="shild">
                        <img src="{{ item.prize_active_image }}" alt="" />
                      </ion-col>
                      <ion-col size="6">
                        <h4 class="shild-amount">{{ item?.prize }}</h4>
                        <p class="prize-win">
                          {{ ("game_details_page.achieved" | translate) ? ("game_details_page.achieved" | translate) : "Achieved" }}
                        </p>
                        <button
                          class="stars-btn"
                          [ngStyle]="{ 'background-color': item.prize_light_color, color: item.prize_dark_color }"
                          >
                          {{ item.star_required }}
                          {{ ("game_details_page.stars" | translate) ? ("game_details_page.stars" | translate) : "Stars" }}
                        </button>
                      </ion-col>
                      <hr class="hr" />
                    </ion-row>
                  }
                }
              }
              @if (isScreenshotsAvailable) {
                <div>
                  <h5 class="ss-text">
                    {{
                    ("game_details_page.screenshots" | translate) ? ("game_details_page.screenshots" | translate) : "Screenshots"
                    }}
                  </h5>
                  <swiper class="screenshots" [config]="ssSlide">
                    @for (s_shot of adventureGame?.screen_shot; track s_shot) {
                      <ng-template swiperSlide class="abc">
                        <img src="{{ s_shot }}" alt="" />
                      </ng-template>
                    }
                  </swiper>
                </div>
              }
              <div class="button-wrapper">
                <ion-button expand="block" shape="round" class="play-now" [disabled]="isButtonDisabled" (click)="playGame(adventureGame); startSpinner()">
                  @if (!spinnerAnimation && proceed) {
                    <span>{{
                      ("game_details_page.play_now" | translate) ? ("game_details_page.play_now" | translate) : "Play now"
                    }}</span>
                  }
                  @if (spinnerAnimation && proceed) {
                    <div class="spinners">
                      <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="30">
                      </mat-progress-spinner>
                    </div>
                  }
                  @if (!proceed && !spinnerAnimation) {
                    <mat-icon [@bounceIn] class="tick-mark">{{
                      ("game_details_page.done_btn" | translate) ? ("game_details_page.done_btn" | translate) : "done"
                    }}</mat-icon>
                  }
                </ion-button>
              </div>
            </ion-content>
          } @else {
            <app-in-progress-animation></app-in-progress-animation>
          }
